import React from 'react';
import { Sun, Moon, Menu } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { NotificationBell } from './NotificationBell';

export const Topbar = ({ title, showMenuButton = false, onMenuClick }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <header
      className="h-16 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between gap-2 px-6 sticky top-0 z-10"
      data-testid="topbar"
    >
      <div className="flex items-center gap-2 min-w-0">
        {showMenuButton && (
          <button
            onClick={onMenuClick}
            className="flex items-center justify-center min-w-11 min-h-11 -ml-2 rounded-md text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
            data-testid="sidebar-open"
            aria-label="Open navigation"
          >
            <Menu size={20} />
          </button>
        )}
        <h1 className="text-xl font-heading font-semibold text-slate-900 dark:text-white truncate">
          {title}
        </h1>
      </div>

      <div className="flex items-center gap-4 shrink-0">
        <NotificationBell />
        <button
          onClick={toggleTheme}
          className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
          data-testid="theme-toggle"
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDark ? (
            <Sun size={20} className="text-amber-400" />
          ) : (
            <Moon size={20} className="text-slate-600" />
          )}
        </button>
      </div>
    </header>
  );
};
